module.exports = __webpack_public_path__ + "img/img6.52a06c09.png";